//Vue imports
import { createRouter, createWebHistory } from "vue-router";

// Our imports
import { validate_route } from "@/utils/auth/auth.js";
import FirstTimeLogin from "@/views/onboarding/FirstTimeLogin/FirstTimeLogin.vue";
import ForgotPassword from "@/views/onboarding/Forgot_password/ForgotPassword.vue";
import HandleSSOLogin from "@/views/onboarding/Handle_SSO_login/HandleSSOLogin.vue";
import UserLogin from "@/views/onboarding/Login/UserLogin.vue";
import OneTimePin from "@/views/onboarding/OneTimePin/OneTimePin.vue";
import ResetPassword from "@/views/onboarding/Reset_password/ResetPassword.vue";
import ResetPasswordSent from "@/views/onboarding/ResetPasswordSent/ResetPasswordSent.vue";
import SignUp from "@/views/probaworkflows_base/entity/entity_onboarding/sign_up/SignUp.vue";
import ConfigureCompanyManagement from "@/views/probaworkflows_base/management/configure_company_management/ConfigureCompanyManagement.vue";
import EnquiryLandingPage from "@/views/probaworkflows_base/management/customer_management/enquiry_landing_page/EnquiryLandingPage.vue";
import ProspectiveApplicant from "@/views/probaworkflows_base/management/customer_management/prospective_applicant/ProspectiveApplicant.vue";
import probaworkflows_routes from "./routes/probaworkflows";

// Get current domain from Django-injected variable
let hostname = window.location.host.split(':')[0]; // without port
let parts = hostname.split('.');
// Remove last part
parts.pop();

// If first part contains 'uat' (case-insensitive), remove it
if (parts[0] && ['uat', 'stage', 'demo'].includes(parts[0].toLowerCase())) {
  parts.shift();
}

const current_domain = parts.join('.');

// Map domains to routes
const domain_route_map = {
  "trustfirst.probaanalytics": probaworkflows_routes,
  "business.complyon": probaworkflows_routes,
  "complyon": probaworkflows_routes,
  "complyon.ai": probaworkflows_routes,
  "aicampus.complyon": probaworkflows_routes,
  "remat": probaworkflows_routes,
  "gov.complyon": probaworkflows_routes,
  "vettedafrica.complyon": probaworkflows_routes,
  "probaworkflows": probaworkflows_routes,
  "bolide.complyon" : probaworkflows_routes,
  "x-verdict" : probaworkflows_routes,
  "ndabenitrust.complyon" : probaworkflows_routes,
};

// routes based on domain or fallback to probaworkflows
const routes = Reflect.get(domain_route_map, current_domain) || probaworkflows_routes;


const common_routes = [
  // Onboarding
  {
    path: "",
    name: "UserLogin",
    component: UserLogin,
    meta: { requires_auth: false, requires_otp: false }, // No authentication required for login
  },
  {
    path: "/handle_sso_login/:token?/:user_id?/:user_role?/:is_aic_one_login?/:current_system?/",
    name: "HandleSSOLogin",
    component: HandleSSOLogin,
    meta: { requires_auth: false, requires_otp: false }, // No authentication required for login
    beforeEnter: (to, from, next) => {
      const token = to.params.token;
      const userId = to.params.user_id;

      if (token && userId) {
        sessionStorage.setItem('token', token);
        sessionStorage.setItem('user_id', userId);
        next();
      } else {
        next('/login');
      }
    }

  },
  {
    path: "/first_time_login",
    name: "FirstTimeLogin",
    component: FirstTimeLogin,
    meta: { requires_otp: false }, // No OTP verification required for first time login
  },
  {
    path: "/one_time_pin",
    name: "OneTimePin",
    component: OneTimePin,
    meta: { requires_otp: false }, // No OTP verification required for one time pin
  },
  {
    path: "/reset_password/:encrypted_link",  // Updated to capture the encrypted link
    name: "ResetPassword",
    component: ResetPassword,
    meta: { requires_auth: false, requires_otp: false },
  },
  {
    path: "/forgot_password",
    name: "ForgotPassword",
    component: ForgotPassword,
    meta: { requires_auth: false, requires_otp: false }, // No authentication required for forgot password
  },
  {
    path: "/reset_password_sent",
    name: "ResetPasswordSent",
    component: ResetPasswordSent,
    meta: { requires_auth: false, requires_otp: false }, // No authentication required for reset password sent
  },


  // Entity Onboarding
  {
    path: "/sign_up/:encrypted_form_id",
    name: "sign_up",
    component: SignUp,
  },

  // Global Components (outside of a project/company)

  {
    path: "/enquiry_landing_page",
    name: "enquiry_landing_page",
    component: EnquiryLandingPage,
    meta: { requires_auth: false, requires_otp: false }, // No authentication required for login
  },
  {
    path: "/prospective_applicant",
    name: "prospective_applicant",
    component: ProspectiveApplicant,
    meta: { requires_auth: false, requires_otp: false }, // No authentication required for login
  },
  {
    path: "/configure_company_management",
    name: "configure_company_management",
    component: ConfigureCompanyManagement,
  },

];

const router = createRouter({
  history: createWebHistory(),
  routes: [...routes, ...common_routes],
});
function is_internal() {
  return process.env.VUE_APP_IS_INTERNAL === 'true';
}

function get_aic_one_login_url() {
  return process.env.VUE_APP_AIC_ONE_LOGIN_URL || null;
}

router.beforeEach((to, from, next) => {
  // Redirect internal apps login page to aic one login
  if (is_internal() && to.path === '/') {
    const url = get_aic_one_login_url();
    if (url) {
      window.location = url;
      return false;
    }
  }
  if (!validate_route(router, to)) return;

  if (current_domain === 'trustfirst' && to.name?.startsWith('other-')) {
    return next('/');
  }

  next();

});




export default router;
